$(document).on('click', '.js-show-toast-btn', function () {
    $('.js-toast-success').addClass('active toast--animated');
    setTimeout(() => {
        $('.js-toast-success').removeClass('active toast--animated');
    }, $(this).data('animation-time'));
});

$(document).on('click', '.js-close-toast', function () {
    $(this).closest('.js-toast').removeClass('active');
});

function showToast(element, status, message, time) {
    let statusClass = '';
    if (status === 'success') {
        statusClass = 'toast--success';
    }
    if (status === 'alert') {
        statusClass = 'toast--alert';
    }

    $(`#${element}`)
        .addClass(`active toast--animated ${statusClass} `)
        .find('.js-toast-text')
        .text(message);

    setTimeout(() => {
        $(`#${element}`).removeClass(`active toast--animated ${statusClass}`);
    }, time);
}
